import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';

export const USER_PLAN_ACCESS_LEVEL_MAP = {
  [UserPlanType.UNAUTHORIZED]: 0,
  [UserPlanType.STARTER]: 1,
  [UserPlanType.PREMIUM]: 2,
  [UserPlanType.PRO]: 3,
} as const;

export const checkAccessByUserPlan = (
  currentPlan: UserPlanType | UserPlanType[],
  requiredPlan: UserPlanType,
): boolean => {
  if (Array.isArray(currentPlan)) {
    return currentPlan.every(
      (plan: UserPlanType) => USER_PLAN_ACCESS_LEVEL_MAP[plan] >= USER_PLAN_ACCESS_LEVEL_MAP[requiredPlan],
    );
  }
  return USER_PLAN_ACCESS_LEVEL_MAP[currentPlan] >= USER_PLAN_ACCESS_LEVEL_MAP[requiredPlan];
};
